import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
import React from "react";
var TypeFormWidget = dynamic(// `@typeform/embed-react` injects styles, which NextJS encodes in SSR, which then leads to server and client hydration mismatch
function() {
    return import("@typeform/embed-react").then(function(mod) {
        return mod.Sidetab;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("@typeform/embed-react")
            ];
        }
    },
    ssr: false
});
export function ShopperFAQ() {
    return /*#__PURE__*/ _jsx(TypeFormWidget, {
        id: "avSmu8nj",
        buttonText: "Get help"
    });
}
